// src/pages/Passaporte/FormSteps.js
import { useState } from 'react';


export const cidadesPorEstado = {
    AC: [
        { codigo: "156", nome: "ACRELÂNDIA" },
        { codigo: "157", nome: "ASSIS BRASIL" },
        { codigo: "105", nome: "BRASILÉIA" },
        { codigo: "106", nome: "BUJARI" },
        { codigo: "108", nome: "CAPIXABA" },
        { codigo: "107", nome: "CRUZEIRO DO SUL" },
        { codigo: "140", nome: "EPITACIOLÂNDIA" },
        { codigo: "113", nome: "FEIJÓ" },
        { codigo: "114", nome: "JORDÃO" },
        { codigo: "155", nome: "MANOEL URBANO" },
        { codigo: "158", nome: "MARECHAL THAUMATURGO" },
        { codigo: "109", nome: "MÂNCIO LIMA" },
        { codigo: "151", nome: "PLÁCIDO DE CASTRO" },
        { codigo: "152", nome: "PORTO ACRE" },
        { codigo: "154", nome: "PORTO WALTER" },
        { codigo: "139", nome: "RIO BRANCO" },
        { codigo: "141", nome: "RODRIGUES ALVES" },
        { codigo: "146", nome: "SANTA ROSA DO PURUS" },
        { codigo: "145", nome: "SENA MADUREIRA" },
        { codigo: "153", nome: "SENADOR GUIOMARD" },
        { codigo: "147", nome: "TARAUACÁ" },
        { codigo: "149", nome: "XAPURI" },
        { codigo: "0", nome: "OUTRA" }
    ],
    AL: [
        { codigo: "2703", nome: "ANADIA" },
        { codigo: "2705", nome: "ARAPIRACA" },
        { codigo: "2707", nome: "ATALAIA" },
        { codigo: "2709", nome: "BARRA DE SANTO ANTÔNIO" },
        { codigo: "2711", nome: "BARRA DE SÃO MIGUEL" },
        { codigo: "2713", nome: "BATALHA" },
        { codigo: "2717", nome: "BELO MONTE" },
        { codigo: "2715", nome: "BELÉM" },
        { codigo: "2719", nome: "BOCA DA MATA" },
        { codigo: "2721", nome: "BRANQUINHA" },
        { codigo: "2723", nome: "CACIMBINHAS" },
        { codigo: "2725", nome: "CAJUEIRO" },
        { codigo: "2726", nome: "CAMPESTRE" },
        { codigo: "2727", nome: "CAMPO ALEGRE" },
        { codigo: "2729", nome: "CAMPO GRANDE" },
        { codigo: "2731", nome: "CANAPI" },
        { codigo: "2733", nome: "CAPELA" },
        { codigo: "2735", nome: "CARNEIROS" },
        { codigo: "2737", nome: "CHÃ PRETA" },
        { codigo: "2739", nome: "COITÉ DO NÓIA" },
        { codigo: "2741", nome: "COLÔNIA LEOPOLDINA" },
        { codigo: "2743", nome: "COQUEIRO SECO" },
        { codigo: "2745", nome: "CORURIPE" },
        { codigo: "2785", nome: "MACEIÓ" },
        { codigo: "0", nome: "OUTRA" }
    ],
    AM: [
        { codigo: "289", nome: "ALVARÃES" },
        { codigo: "291", nome: "AMATURÁ" },
        { codigo: "293", nome: "ANAMÃ" },
        { codigo: "203", nome: "ANORI" },
        { codigo: "204", nome: "APUÍ" },
        { codigo: "205", nome: "ATALAIA DO NORTE" },
        { codigo: "207", nome: "AUTAZES" },
        { codigo: "209", nome: "BARCELOS" },
        { codigo: "211", nome: "BARREIRINHA" },
        { codigo: "213", nome: "BENJAMIN CONSTANT" },
        { codigo: "255", nome: "MANAUS" },
        { codigo: "0", nome: "OUTRA" }
    ],

    



};



// Estado inicial do formulário de passaporte
export function usePassportFormState() {
    const initialState = {
        nome: '',
        cpf: '',
        sexo: '',
        dataNascimento: '',
        estadoCivil: '',
        estadoNascimento: '',
        cidadeNascimento: '',
        racaOuCor: '',
        outroNome: '',
        profissao: '',
        email: '',
        endereco: '',
        cep: '',
        telefone: '',
        jaTevePassaporte: '',
        postoPF: '',
        formaPagamento: '',
        certidaoNascimento: null,
        certidaoCasamento: null,
        documentoIdentificacao: null,
        numeroDoc: '',
        orgaoDoc: '',
        estadoDoc: '',
        dataEmissaoDoc: '',
    };

    const [formData, setFormData] = useState(initialState);

    const setFormField = (field, value) => {
        setFormData((prevData) => ({ ...prevData, [field]: value }));
    };

    return [formData, setFormField];
}

// Componente para informações pessoais
export function InformacoesPessoaisPassport({ formData, handleInputChange, errors }) {
    return (
        <div>
            <h3>Informações Pessoais</h3>
            <div>
                <label>Nome:</label>
                <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>CPF:</label>
                <input
                    type="text"
                    name="cpf"
                    value={formData.cpf}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Data de Nascimento:</label>
                <input
                    type="date"
                    name="dataNascimento"
                    value={formData.dataNascimento}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Sexo:</label>
                <select
                    name="sexo"
                    value={formData.sexo}
                    onChange={handleInputChange}
                >
                    <option value="">- Selecione um -</option>
                    <option value="M">Homem</option>
                    <option value="F">Mulher</option>
                </select>
            </div>
            <div>
                <label>Estado Civil:</label>
                <select
                    name="estadoCivil"
                    value={formData.estadoCivil}
                    onChange={handleInputChange}
                >
                    <option value=""></option>
                    <option value="1">Solteiro(a)</option>
                    <option value="2">Casado(a)</option>
                    <option value="3">Viúvo(a)</option>
                    <option value="4">Separado(a) Judicialmente</option>
                    <option value="5">Divorciado(a)</option>
                    <option value="6">União Estável</option>
                </select>
            </div>


            <div>
                <label>Estado Nascimento:</label>
                <select
                    name="estadoNascimento"
                    value={formData.estadoNascimento}
                    onChange={handleInputChange}
                >
                    <option value=""></option>
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AM">AM</option>
                    <option value="AP">AP</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MG">MG</option>
                    <option value="MS">MS</option>
                    <option value="MT">MT</option>
                    <option value="PA">PA</option>
                    <option value="PB">PB</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="PR">PR</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RO">RO</option>
                    <option value="RR">RR</option>
                    <option value="RS">RS</option>
                    <option value="SC">SC</option>
                    <option value="SE">SE</option>
                    <option value="SP">SP</option>
                    <option value="TO">TO</option>
                </select>
            </div>





            <div>
                <label>Cidade/Estado de Nascimento:</label>
                <input
                    type="text"
                    name="cidadeNascimento"
                    value={formData.cidadeNascimento}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Raça ou Cor:</label>
                <select
                    name="racaOuCor"
                    value={formData.racaOuCor}
                    onChange={handleInputChange}
                >
                    <option value=""></option>
                    <option value="1">Amarela</option>
                    <option value="2">Branca</option>
                    <option value="3">Indígena</option>
                    <option value="4">Parda</option>
                    <option value="5">Preta</option>
                    <option value="8">Outras</option>
                    <option value="9">Não desejo declarar</option>
                </select>
            </div>



            <div>
                <label>Já teve outro nome? Se sim, diga qual:</label>
                <input
                    type="text"
                    name="outroNome"
                    value={formData.outroNome}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Profissão:</label>
                <input
                    type="text"
                    name="profissao"
                    value={formData.profissao}
                    onChange={handleInputChange}
                />
            </div>
        </div>
    );
}

// Componente para endereço e contato
export function EnderecoEContatoPassport({ formData, handleInputChange, errors }) {
    return (
        <div>
            <h3>Endereço e Contato</h3>
            <div>
                <label>Email:</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Endereço:</label>
                <input
                    type="text"
                    name="endereco"
                    value={formData.endereco}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>CEP:</label>
                <input
                    type="text"
                    name="cep"
                    value={formData.cep}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Telefone:</label>
                <input
                    type="text"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleInputChange}
                />
            </div>
        </div>
    );
}

// Componente para informações adicionais
export function InformacoesAdicionaisPassport({ formData, handleInputChange, errors }) {
    return (
        <div>
            <h3>Documento Pessoal (identidade ou CNH)</h3>
            <div>
                <label>Qual número de identificação do seu documento?</label>
                <input
                    type="text"
                    name="numeroDoc"
                    value={formData.numeroDoc}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Qual orgão emitiu o seu documento?</label>
                <input
                    type="text"
                    name="orgaoDoc"
                    value={formData.orgaoDoc}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Em qual estado o seu documento foi emitido?</label>
                <input
                    type="text"
                    name="estadoDoc"
                    value={formData.estadoDoc}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Data de Emissão:</label>
                <input
                    type="date"
                    name="dataEmissaoDoc"
                    value={formData.dataEmissaoDoc}
                    onChange={handleInputChange}
                />
            </div>










            <h3>Informações Adicionais</h3>
            <div>
                <label>Já teve passaporte?</label>
                <select
                    name="jaTevePassaporte"
                    value={formData.jaTevePassaporte}
                    onChange={handleInputChange}
                >
                    <option value="">Selecione</option>
                    <option value="sim">Sim</option>
                    <option value="nao">Não</option>
                </select>
            </div>

            <div>
                <label>Qual posto da PF mais próximo da sua casa?</label>
                <input
                    type="text"
                    name="postoPF"
                    value={formData.postoPF}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Forma de pagamento:</label>
                <select
                    name="formaPagamento"
                    value={formData.formaPagamento}
                    onChange={handleInputChange}
                >
                    <option value="">Selecione</option>
                    <option value="boleto">Boleto</option>
                    <option value="cartaoCredito">Cartão de Crédito</option>
                </select>
            </div>

            <div>
                <label>-Enviar certidão de nascimento (para menores de 12 anos):</label>
                {/* <input
                    type="file"
                    name="certidaoNascimento"
                    onChange={(e) =>
                        handleInputChange('certidaoNascimento', e.target.files[0])
                    }
                /> */}
            </div>

            <div>
                <label>-Enviar certidão de casamento (em caso de mudança de nome):</label>
                {/* <input
                    type="file"
                    name="certidaoCasamento"
                    onChange={(e) =>
                        handleInputChange('certidaoCasamento', e.target.files[0])
                    }
                /> */}
            </div>

            <div>
                <label>-Enviar documento de identificação pessoal:</label>
                {/* <input
                    type="file"
                    name="documentoIdentificacao"
                    onChange={(e) =>
                        handleInputChange('documentoIdentificacao', e.target.files[0])
                    }
                /> */}
            </div>
        </div>
    );
}
